'use client'

import { type FC } from 'react'
import { useHits } from 'react-instantsearch'

import { type AlgoliaProxyRecord } from '../../algolia'
import {
  ProductSellerVoucherLabelDiscountDialogContextProvider,
  ProductVolumePricingContextProvider,
} from '../../product'

import {
  ProductSearchResultItem,
  ProductSearchResultItemContextProvider,
} from './ProductSearchResultItem'
import { mapAlgoliaVolumeBasedPrices } from './useProductSearchMapVolumeBasedPrices'

export const ProductSearchPromotionResultList: FC = () => {
  const { items: algoliaHits, results } = useHits<AlgoliaProxyRecord>()
  const items = algoliaHits.filter((item) => item.productName)

  return (
    <ul className="grid gap-9">
      {items.map((item) => (
        <li data-qa-id="promotion-products-result-list-entry" key={item.id}>
          <ProductSearchResultItemContextProvider
            algoliaRecord={item}
            query={results?.query}
          >
            <ProductVolumePricingContextProvider
              currentVariantUpid={item.upid}
              volumeBasedPrices={mapAlgoliaVolumeBasedPrices(
                item.best_offer?.volume_based_prices,
              )}
            >
              <ProductSellerVoucherLabelDiscountDialogContextProvider
                value={{
                  showLinkToPromotionPage: false,
                  showRecommendations: false,
                  termsExpanded: true,
                }}
              >
                <ProductSearchResultItem />
              </ProductSellerVoucherLabelDiscountDialogContextProvider>
            </ProductVolumePricingContextProvider>
          </ProductSearchResultItemContextProvider>
        </li>
      ))}
    </ul>
  )
}
